import { z } from 'zod';
import { ProcessConnectionSchema } from '../../entities/process-connection/process-connection.schema';
/**
 * Get Process Connections Response Schema
 * GET /api/v2/process/:id/connections
 */ export const GetProcessConnectionsResponseSchema = z.object({
    connections: z.array(ProcessConnectionSchema.extend({
        sourceProcess: z.object({
            _id: z.string(),
            name: z.string()
        }),
        targetProcess: z.object({
            _id: z.string(),
            name: z.string()
        }),
        sourcePortName: z.string().optional(),
        targetPortName: z.string().optional()
    }))
});

//# sourceMappingURL=get-process-connections.schema.js.map